<template>
  <v-form :action="url" ref="entrypoint" enctype="multipart/form-data" method="POST" v-on:submit.stop.prevent="submitForm">
    <v-container>
      <div name="dropzone" class="dropzone" :id="id" :numMaxArquivos="numMaxArquivos"></div>
      <div style="min-height: 20px;" >
        <v-scroll-y-transition >
          <span class="red--text caption" v-show="exibirMensagem">
            {{ $t('label.upload_arquivo_obrigatorio') }}
          </span>
        </v-scroll-y-transition>
      </div>
    </v-container>
  </v-form>
</template>

<script>
import Dropzone from 'dropzone';
import { auth } from '../../config/sso/auth';

Dropzone.autoDiscover = false;

export default {
  name: 'DropzoneFormNovo',
  props: {
    id: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    numMaxArquivos: {
      type: Boolean,
      default: false,
    },
    clickable: {
      type: Boolean,
      default: true,
    },
    thumbnailHeight: {
      type: Number,
      default: 200,
    },
    thumbnailWidth: {
      type: Number,
      default: 200,
    },
    showRemoveLink: {
      type: Boolean,
      default: true,
    },
    maxFileSizeInMB: {
      type: Number,
      default: 500,
    },
    maxNumberOfFiles: {
      type: Number,
      default: 10,
    },
    autoProcessQueue: {
      type: Boolean,
      default: true,
    },
    dropzoneOptions: {
      type: Object,
      default() { return null; },
    },
    acceptedFileTypes: {
      type: String,
    },
    timeout: {
      type: Number,
      default: 120000,
    },
    customValidate: Function,
  },
  data() {
    return {
      dropzone: null,
      quantidadeArquivo: 0,
      arquivosEnviados: 0,
      exibirMensagem: false,
    };
  },
  computed: {
    addIcon() {
      return '<i class="material-icons" style="color: #9D1D96;">upload_file</i>';
    },
    doneIcon() {
      return '<i class="material-icons">done</i>';
    },
    errorIcon() {
      return '<i class="material-icons">error</i>';
    },
  },
  watch: {
    url() {
      this.recreateDropzone();
    },
    id() {
      this.recreateDropzone();
    },
    numMaxArquivos() {
      this.removeAllFiles();
    },
  },
  methods: {
    submitForm() {
      if (this.quantidadeArquivo < 1) {
        this.exibirMensagem = true;
      }
      if (this.validateForm() && !this.exibirMensagem) {
        this.dropzone.processQueue();
      }
    },
    resetForm() {
      this.$refs.entrypoint.reset();
      this.quantidadeArquivo = 0;
      this.exibirMensagem = false;
      if (this.dropzone) {
        this.dropzone.removeAllFiles(true);
      }
    },
    resetValidationForm() {
      this.exibirMensagem = false;
      this.$refs.entrypoint.resetValidation();
    },
    validateForm() {
      return this.$refs.entrypoint.validate()
        && (!this.customValidate || this.customValidate());
    },
    removeAllFiles() {
      this.dropzone.removeAllFiles(true);
    },
    processQueue() {
      this.dropzone.processQueue();
    },
    recreateDropzone() {
      this.dropzone.destroy();
      this.dropzone = null;
      document.querySelector(`#${this.id}`).innerHTML = '';
      this.initDropzone();
    },
    createDropzoneElement() {
      let element = document.getElementById(this.id);
      if (!element) {
        element = this.$refs.entrypoint.querySelector('.dropzone');
      }
      return element;
    },
    title() {
      return `<u style='color: #9D1D96;'>Clique para carregar</u> ou <strong>arraste e solte</strong><br>PDF, DOC ou JPG (Max. ${this.maxFileSizeInMB}MB)`;
    },
    createDropzone() {
      const element = this.createDropzoneElement();
      this.dropzone = (!this.dropzoneOptions)
        ? new Dropzone(element, {
          url: this.url,
          addRemoveLinks: this.showRemoveLink,
          acceptedFiles: this.acceptedFileTypes,
          autoProcessQueue: this.autoProcessQueue,
          clickable: this.clickable,
          dictCancelUpload: 'Cancelar',
          dictCancelUploadConfirmation: 'Tem certeza que deseja cancelar o envio?',
          dictDefaultMessage: `${this.addIcon}<br>${this.title()}`,
          dictFallbackMessage: 'O seu browser não suporta esta feature. Use o Google Chrome.',
          dictFileTooBig: `O arquivo é muito grande! O máximo suportado é ${this.maxFileSizeInMB}MB`,
          dictInvalidFileType: `Este arquivo não é suportado. Os tipos aceitos são: ${this.acceptedFileTypes}`,
          dictResponseError: 'Erro no nosso servidor. Reenvie o arquivo.',
          dictRemoveFile: 'Remover arquivo',
          maxFilesize: this.maxFileSizeInMB,
          parallelUploads: this.maxNumberOfFiles,
          timeout: this.timeout,
          accept: (file, done) => {
            if (auth.isTokenExpired()) {
              auth.refreshToken().then(() => done());
            } else {
              done();
            }
          },
          previewTemplate: `
              <div class="dz-preview dz-file-preview">
                <div class="dz-image" style="width: ${this.thumbnailWidth}px; height:${this.thumbnailHeight}px">
                  <img data-dz-thumbnail />
                </div>
                <div class="dz-details">
                  <div class="dz-size">
                    <span data-dz-size></span>
                  </div>
                  <div class="dz-filename">
                    <span data-dz-name></span>
                  </div>
                </div>
                <div class="dz-progress">
                  <span class="dz-upload" data-dz-uploadprogress></span>
                </div>
                <div class="dz-error-message">
                  <span data-dz-errormessage></span>
                </div>
                <div class="dz-success-mark">${this.doneIcon}</div>
                <div class="dz-error-mark">${this.errorIcon}</div>
              </div>`,
          thumbnailWidth: this.thumbnailWidth,
          thumbnailHeight: this.thumbnailHeight,
        })
        : new Dropzone(element, this.dropzoneOptions);
    },
    initDropzone() {
      this.createDropzone();
      this.registerDropzoneEvents();
    },
    removeFile(file) {
      this.dropzone.removeFile(file);
    },
    validateFileSize(file) {
      if (file.size < this.maxFileSizeInMB * 1000000) {
        return true;
      }
      return false;
    },
    registerDropzoneEvents() {
      this.dropzone.on('addedfile', (file) => {
        if (!this.validateFileSize(file)) {
          this.$emit('UPLOADFILE_ERROR', file, 'Tamanho do arquivo invalido');
          this.dropzone.removeFile(file);
          return;
        }
        this._batchCount = (this._batchCount || 0) + 1;
        this.quantidadeArquivo += 1;
        this.exibirMensagem = false;
        this.$emit('UPLOADFILE_FILE_ADDED', file);
        clearTimeout(this._submitTimeout);
        this._submitTimeout = setTimeout(() => {
          const batchSize = this._batchCount;
          this._batchCount = 0;
          if (batchSize > this.maxNumberOfFiles) {
            this.dropzone.removeAllFiles(true);
            this.$emit('UPLOADFILE_ERROR', null, `${this.$t('label.quantidade_arquivos_maximo')}${this.maxNumberOfFiles}.`);
            return;
          }
          this.submitForm();
        }, 2000);
      });

      this.dropzone.on('removedfile', (file) => {
        this.quantidadeArquivo -= 1;
        if (this.quantidadeArquivo < 0) this.quantidadeArquivo = 0;
        this.$emit('UPLOADFILE_FILE_REMOVED', file);
      });

      this.dropzone.on('success', (file) => {
        this.arquivosEnviados += 1;
        setTimeout(() => this.dropzone.removeFile(file), 2000);
      });

      this.dropzone.on('queuecomplete', () => {
        if (this.arquivosEnviados > 0) {
          this.$emit('UPLOADFILE_SUCCESS');
          this.arquivosEnviados = 0;
        }
      });

      this.dropzone.on('error', (file, error, xhr) => {
        this.$emit('UPLOADFILE_ERROR', file, error, xhr);
      });

      this.dropzone.on('sending', (file, xhr, formData) => {
        if (sessionStorage && sessionStorage.token) {
          const token = this.$auth.token || sessionStorage.token;
          xhr.setRequestHeader('Authorization', `Bearer ${token}`);
        }
        const fn = encodeURI(file.name);
        formData.append('filename', fn);
        this.$emit('UPLOADFILE_SENDING', file, xhr, formData);
      });
    },
    startComponent() {
      this.initDropzone();
    },
  },
  mounted() {
    this.startComponent();
  },
};
</script>

<style src="./Dropzone.scss" lang="scss"></style>
